import { useRef } from 'react';
import areValuesEqual from '@/components/Questionnaire/form/helpers/areValuesEqual';
import parseFieldKey from '@/components/Questionnaire/form/helpers/parseFieldKey';
import { useQuestionnaireContext, useQuestionnaireFormContext } from '@/components/Questionnaire/QuestionnaireProvider';

type Props = {
  aiAgent: { fieldData: string[], aiModel: string };
  enabled: boolean;
};

const useInputFieldKeys = ({ aiAgent, enabled }: Props): string[] => {
  const {
    fieldsByKey,
    fieldsById,
  } = useQuestionnaireContext();
  const { formMethods } = useQuestionnaireFormContext();

  const storedFieldKeys = useRef<string[]>([]);

  const dependentFieldKeys = (enabled && aiAgent.fieldData)
    ? aiAgent.fieldData.flatMap((fieldKey) => {
      const field = fieldsByKey[fieldKey];
      if (field?.listFieldTemplateId) {
        const listField = fieldsById[field.listFieldTemplateId];
        if (listField) {
          const listFieldValues = formMethods.getValues()[listField.key];
          if (!listFieldValues || !Array.isArray(listFieldValues) || listFieldValues?.length === 0) {
            return [];
          }
          // @todo - performance, filter out the rowIndexes that are not in the filter.
          // But need to check that it's the correct list.
          return listFieldValues.map((__, index) => `${listField.key}[${index}].${fieldKey}`);
        }
      }
      return fieldKey;
    })
    : [];

  if (aiAgent.aiModel === 'boxIndex') {
    dependentFieldKeys.forEach((key) => {
      const values = parseFieldKey(key);
      if (values.listFieldKey) {
        dependentFieldKeys.push(`${values.listFieldKey}[${values.rowIndex}]._associatedWithId`);
      }
    });
  }

  if (!areValuesEqual(dependentFieldKeys, storedFieldKeys.current)) {
    storedFieldKeys.current = dependentFieldKeys;
  }

  return storedFieldKeys.current;
};

export default useInputFieldKeys;
